import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { FireBaseObjectNames } from '../../../core/codes';
import { AngularFireDatabaseWrapper } from '../../../providers/angularfire-wrapper';
//import  * as Rx  from 'rxjs';

//import _ from 'lodash';

@Injectable()
export class DynamicPageData {

    constructor(
        public afw: AngularFireDatabaseWrapper 
        ) {
    }

    public getPageData(pId) {
        var self = this;
        var result = self.afw.object(FireBaseObjectNames.DYNAMIC_PAGE + '/' + pId, undefined, true).map(val => {
            return val;
        });

        return result;
    }
}


// WEBPACK FOOTER //
// ./src/modules/dynamic-page/providers/dynamic-page-data.ts